<template>
  <div class="pase-digital-container">
    <!-- Tarjeta del Pase Digital -->
    <div class="card">
      <!-- Encabezado -->
      <div class="card-header">
        <h2 class="card-title">Pase Digital</h2>
      </div>

      <!-- Cuerpo -->
      <div class="card-body">
        <!-- QR existente (solo imagen) -->
        <div class="qr-container">
          <img 
            :src="qrImageUrl" 
            alt="Código QR del pase"
            class="qr-image"
          />
          <p class="qr-hint">Escanee este código para verificar</p>
        </div>

        <!-- Información del invitado -->
        <div class="guest-info">
          <div class="info-item">
            <span class="info-label">Invitado</span>
            <span class="info-value nombre">{{ invitado.nombre_mostrar }}</span>
          </div>

          <div class="details-grid">
            <div class="detail-box">
              <span class="detail-label">Pases</span>
              <span class="detail-value">{{ invitado.num_pases }}</span>
            </div>
            <div class="detail-box">
              <span class="detail-label">Mesa</span>
              <span class="detail-value">{{ invitado.num_mesa }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Pie de tarjeta -->
      <div class="card-footer">
        <p>{{ evento.nombre }}</p>
        <p class="fecha">{{ evento.fecha }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaseDigital",
  props: {
    qrImageUrl: {
      type: String,
      required: true
    },
    invitado: {
      type: Object,
      default: () => ({
        nombre_mostrar: "Nombre del Invitado",
        num_pases: "0",
        num_mesa: "0"
      })
    },
    evento: {
      type: Object,
      default: () => ({
        nombre: "Evento Ejemplo",
        fecha: "1 de Enero, 2023"
      })
    }
  }
};
</script>

<style scoped>
.pase-digital-container {
  max-width: 100%;
  padding: 20px;
  display: flex;
  justify-content: center;
}

.card {
  width: 100%;
  max-width: 350px;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  font-family: 'Arial', sans-serif;
}

.card-header {
  background: #4a3f42;
  color: white;
  padding: 15px;
  text-align: center;
}

.card-title {
  margin: 0;
  font-size: 1.4rem;
}

.card-body {
  padding: 20px;
}

.qr-container {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px dashed #e0e0e0;
}

.qr-image {
  width: 150px;
  height: 150px;
  margin: 0 auto;
  display: block;
}

.qr-hint {
  font-size: 0.8rem;
  color: #666;
  margin-top: 8px;
}

.guest-info {
  margin-top: 15px;
}

.info-item {
  margin-bottom: 15px;
}

.info-label {
  display: block;
  font-size: 0.7rem;
  color: #888;
  text-transform: uppercase;
  margin-bottom: 3px;
}

.info-value {
  font-size: 1.1rem;
  color: #333;
}

.nombre {
  font-size: 1.4rem;
  font-weight: bold;
  color: #4a3f42;
}

.details-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-top: 20px;
}

.detail-box {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 10px;
  text-align: center;
}

.detail-label {
  font-size: 0.7rem;
  color: #666;
  display: block;
}

.detail-value {
  font-size: 1.4rem;
  font-weight: bold;
  color: #8e6e53;
  display: block;
}

.card-footer {
  background: #f9f9f9;
  padding: 12px;
  text-align: center;
  font-size: 0.8rem;
  color: #666;
}

.fecha {
  font-weight: bold;
  color: #4a3f42;
  margin-top: 5px;
}
</style>